<template>
    <modal
        :saveAction="saveAction"
        no-fade="true"
        :title="title + '' + exam.tooth + '  / ' + customer.first_name + ' ' + customer.last_name"
        :id="id"
        :actionButtons="true"
        size="full"
        :closeButton="false"
        @shown="shown"
    >
        <ul class="nav nav-tabs mb-5 p-0">
            <li class="nav-item">
                <a
                    href="#"
                    @click.prevent="tab ='presets'"
                    class="nav-link"
                    :class="{active:tab == 'presets'}"
                >{{ $t('Treatment presets') }}</a>
            </li>
            <li class="nav-item">
                <a
                    href="#"
                    @click.prevent="tab ='complaints'"
                    class="nav-link"
                    :class="{active:tab == 'complaints'}"
                >{{ $t('Details') }}</a>
            </li>

            <li class="nav-item">
                <a
                    href="#"
                    @click.prevent="tab ='treatment'"
                    class="nav-link"
                    :class="{active:tab == 'treatment'}"
                >{{ $t('Treatment') }}</a>
            </li>
            <li class="nav-item">
                <a
                    href="#"
                    @click.prevent="tab ='notes'"
                    class="nav-link"
                    :class="{active:tab == 'notes'}"
                >{{ $t('Notes') }}</a>
            </li>
        </ul>

        <div>
            <div v-if="tab =='presets'">
                <div v-if="arePresetsLoading">{{ $('Loading...') }}</div>
                <div
                    class="text-center text-muted small"
                    v-else-if="!arePresetsLoading && !presetQuery && !presetSpecialty && presets.length==0"
                >
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-10 col-xl-8">
                            <!-- Image -->
                            <img
                                src="@/assets/img/illustrations/designer-life.svg"
                                alt="..."
                                class="img-fluid"
                                style="width: 250px;"
                            />
                            <h2>{{ $t('No treatment templates') }}</h2>
                            <p class="text-muted">{{ $t('Try creating first by saving your current exam') }}</p>
                            <button class="btn mb-2 btn-outline-primary" @click="tab='complaints'">
                                <i class="fe fe-plus"/>
                                {{ $t('New template') }}
                            </button>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="col-3">
                            <ul class="navbar-nav">
                                <li class="nav-item">
                                    <div class="nav-link pointer" :class="{'active': presetSpecialty === 'recent'}">
                                        <a
                                            href="#"
                                            class="active"
                                            @click.stop.prevent="presetSpecialty='recent'"
                                        >{{ $t('Recently used') }}</a>
                                        <button class="ml-3 btn btn-white btn-sm" @click="clearPresetSpecialty" v-if="presetSpecialty === 'recent'">
                                            <i class="fe fe-x"></i>
                                        </button>
                                    </div>
                                </li>
                                <li class="nav-item">
                                    <div class="nav-link pointer" :class="{'active': presetSpecialty === 'my'}">
                                        <a href="#" @click.stop.prevent="presetSpecialty='my'">{{ $t('My templates') }}</a>
                                        <button class="ml-3 btn btn-white btn-sm" @click="clearPresetSpecialty" v-if="presetSpecialty === 'my'">
                                            <i class="fe fe-x"></i>
                                        </button>
                                    </div>
                                </li>
                            </ul>
                            <specialty-nav v-model="presetSpecialty"/>
                        </div>
                        <div class="col-9">
                            <div class="card px-2">
                                <div class="row align-items-center">
                                    <div class="col-auto pr-0">
                                        <span class="fe fe-x text-muted" v-if="presetQuery" @click="presetQuery=null"></span>
                                        <span class="fe fe-search text-muted" v-else></span>
                                    </div>
                                    <div class="col">
                                        <!-- <input type="search" class="form-control form-control-flush search no-glow"> -->
                                        <b-form-input
                                            v-model="presetQuery"
                                            :autofocus="true"
                                            class="no-glow search form-control-flush border"
                                            :placeholder="$t('Search')"
                                        ></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div
                                    class="col-12 text-center small text-muted"
                                    v-if="!arePresetsLoading && presets.length ==0"
                                >{{ $t('Nothing yet') }}
                                </div>
                                <div class="col-6" v-for="preset in presets" :key="preset._id">
                                    <div class="card pointer hover" @click="set(preset)">
                                        <div class="card-body p-3">
                                            <div class="p-0 m-0">{{ preset.label }}</div>
                                            <div class="text-muted m-0 small">
                                                <span v-for="icd in preset.icdFinal" :key="icd._id">{{ icd.label }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="tab =='complaints'">
                <div class="row">
                    <div class="col-4 text-center text-muted p-5" v-if="exam.cdb.length<=0">
                        <div class="row justify-content-center">
                            <div class="col">
                                <!-- Image -->
                                <img
                                    src="@/assets/img/illustrations/meditate.svg"
                                    alt="..."
                                    class="img-fluid mt-n5 mb-4"
                                    style="max-width: 272px;"
                                />
                                <h2>{{ $t('Complaints') }}</h2>
                                <p class="text-muted">{{ $t('All exams history will be here') }}</p>

                                <button
                                    @click="openModal({ id: 'CdbModal', model: {} });"
                                    class="btn btn-primary"
                                >{{ $t('Browse') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-4" v-else>
                        <div class="card card-inactive">
                            <div class="card-header p-2">
                                <div class="row align-items-center m-0">
                                    <div class="col">{{ $t('Complaints') }}</div>
                                    <div class="col-auto">
                                        <button
                                            class="btn btn-sm btn-info"
                                            @click="openModal({ id: 'CdbModal', model: {} });"
                                        >
                                            <i class="fe fe-plus"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-2">
                                <div
                                    class="p-4 text-center text-muted small"
                                    v-if="exam.cdb.length==0"
                                >{{ $t('Nothing yet') }}
                                </div>

                                <div class="kanban-category" tabindex="0">
                                    <div class="kanban-item" tabindex="0">
                                        <draggable v-model="exam.cdb" :options="{animation:350}">
                                            <div class="card mb-1" v-for="(item, index) in exam.cdb" :key="index">
                                                <div class="card-body p-2">
                                                    <div class="row align-items-center">
                                                        <div class="col-auto pointer">
                                                            <i class="fe fe-more-vertical"></i>
                                                        </div>
                                                        <div class="col-auto">
                                                            <strong>{{ item.code }}</strong>
                                                        </div>
                                                        <div class="col">
                                                            {{ item.label }}
                                                            <div
                                                                class="text-muted small"
                                                                v-if="item.description"
                                                            >{{ item.description }}
                                                            </div>
                                                        </div>
                                                        <div class="col-auto">
                                                            <button
                                                                class="btn btn-white btn-sm mr-1"
                                                                @click="removeCdb(index)"
                                                            >
                                                                <i class="fe fe-x"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </draggable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-4 text-center text-muted p-5" v-if="exam.odb.length<=0">
                        <div class="row justify-content-center">
                            <div class="col">
                                <!-- Image -->
                                <img
                                    src="@/assets/img/illustrations/lost.svg"
                                    alt="..."
                                    class="img-fluid mt-n5 mb-4"
                                    style="max-width: 272px;"
                                />
                                <h2>{{ $t('Objectivly') }}</h2>
                                <p class="text-muted">{{ $t('Objectivly checks') }}</p>

                                <button
                                    @click="openModal({ id: 'OdbModal', model: {} });"
                                    class="btn btn-primary"
                                >{{ $t('Browse') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-4" v-else>
                        <div class="card card-inactive">
                            <div class="card-header p-2">
                                <div class="row align-items-center m-0">
                                    <div class="col">{{ $t('Objectively') }}</div>
                                    <div class="col-auto">
                                        <button
                                            class="btn btn-sm btn-info"
                                            @click="openModal({ id: 'OdbModal', model: {} });"
                                        >
                                            <i class="fe fe-plus"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="p-4 text-center text-muted small"
                                v-if="exam.odb.length==0"
                            >{{ $t('Nothing yet') }}
                            </div>
                            <div class="card-body p-2">
                                <div class="kanban-category" tabindex="0">
                                    <div class="kanban-item" tabindex="0">
                                        <draggable v-model="exam.odb" :options="{animation:350}">
                                            <div class="card mb-1" v-for="(odbItem, index) in exam.odb" :key="index">
                                                <div class="card-body p-2">
                                                    <div class="row mb-2 align-items-center">
                                                        <div class="col-auto pointer">
                                                            <i class="fe fe-more-vertical"></i>
                                                        </div>
                                                        <div class="col">{{ odbItem.label }}</div>
                                                        <div class="col-auto">
                                                            <button
                                                                class="btn btn-white btn-sm mr-1"
                                                                @click="removeOdb(index)"
                                                            >
                                                                <i class="fe fe-x"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="row align-items-center">
                                                        <div class="col">
                                                            <b-form-select multiple size="sm" v-model="odbItem.value">
                                                                <option
                                                                    v-for="(item, index) in odbItem.fields"
                                                                    :value="item.value"
                                                                    v-b-tooltip.hover
                                                                    :title="item.value"
                                                                    :key="index"
                                                                >{{ item.value }}
                                                                </option>
                                                            </b-form-select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </draggable>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer p-2" v-if="exam.odb.length>=3">
                                <div class="row align-items-center m-0">
                                    <div class="col"></div>
                                    <div class="col-auto">
                                        <button
                                            class="btn btn-sm btn-info"
                                            @click="openModal({ id: 'OdbModal', model: {} });"
                                        >
                                            <i class="fe fe-plus"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-4 text-center text-muted p-5" v-if="exam.diagnosisFinal.length<=0">
                        <div class="row justify-content-center">
                            <div class="col">
                                <!-- Image -->
                                <img
                                    src="@/assets/img/illustrations/happiness.svg"
                                    alt="..."
                                    class="img-fluid mt-n5 mb-4"
                                    style="max-width: 272px;"
                                />
                                <h2>{{ $t('Diagnosis') }}</h2>
                                <p class="text-muted">{{ $t('Please select final diagnonsis') }}</p>

                                <button
                                    @click="openModal({ id: 'ICDModalFinal', model: {} });"
                                    class="btn btn-primary"
                                >{{ $t('Browse') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-4" v-else>
                        <div class="card card-inactive">
                            <div class="card-header p-2">
                                <div class="row align-items-center m-0">
                                    <div class="col">{{ $t('Final diagnosis') }}</div>
                                    <div class="col-auto">
                                        <button
                                            class="btn btn-sm btn-info"
                                            @click="openModal({ id: 'ICDModalFinal', model: {} });"
                                        >
                                            <i class="fe fe-plus"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-2">
                                <div
                                    class="p-4 text-center text-muted small"
                                    v-if="exam.diagnosisFinal.length==0"
                                >{{ $t('Nothing yet') }}
                                </div>

                                <div class="card mb-1" v-for="(item, index) in exam.diagnosisFinal" :key="index">
                                    <div class="card-body p-2">
                                        <div class="row align-items-center">
                                            <div class="col-auto">
                                                <strong>{{ item.code }}</strong>
                                            </div>
                                            <div class="col">{{ item.label }}</div>
                                            <div class="col-auto">
                                                <button
                                                    class="btn btn-white btn-sm mr-1"
                                                    @click="removeDiangosisFinal(index)"
                                                >
                                                    <i class="fe fe-x"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="tab=='treatment'">
                <div class="row">
                    <div class="col-12 col-md-8" style="max-height:75vh; overflow-y:auto">
                        <div
                            class="card card-inactive p-2 text-center text-muted small"
                            v-if="exam.treatments.length==0"
                        >{{ $t('Nothing yet') }}
                        </div>

                        <treatment-loop v-else v-model="exam.treatments"></treatment-loop>

                        <button class="btn btn-info my-3" @click="openModal({ id: 'TreatmentBrowserModal1' });">
                            <i class="fe fe-activity"></i>
                            {{ $t('Add treatment') }}
                        </button>
                    </div>
                    <div class="col-12 col-md-4 text-center">
                        <div class="d-flex justify-content-center align-items-center flex-column">
                            <div class="h2">{{ $t('Tooth #') }}: {{ exam.tooth }}</div>
                            <tooth-parts :tooth="exam.tooth" :width="80" v-model="exam.parts"></tooth-parts>
                        </div>
                        <div class="mt-4">
                            <div class="h2 mb-3">{{ $t('Pre-treatment status') }}:</div>
							<div class="d-flex justify-content-center align-items-center mb-3 flex-wrap">
									<span
										style="font-size:12px"
										class="badge badge-warning badge-pill mr-1 mb-2"
										v-for="condition in exam.condition"
										:key="condition"
									>{{ conditionLabel(condition) }}</span>
							</div>
                            <treeselect
                                v-model="exam.condition"
                                :multiple="true"
                                :max-height="150"
                                :always-open="false"
                                :append-to-body="false"
                                openDirection="below"
                                valueFormat="id"
                                :disable-branch-nodes="true"
                                :options="conditions"
                            />
                        </div>
                        <div class="mt-5" v-if="modified">
                            <div class="row">
                                <div class="col-auto">
                                    <custom-switch
                                        id="saveAsPreset"
                                        v-model="saveAsPreset"
                                        :title="$t('Save as template')"
                                    ></custom-switch>
                                </div>
                                <div class="col-12" v-if="saveAsPreset">
                                    <b-form-input :label="$t('Name')" v-model="exam.newPresetName"/>
                                </div>
                            </div>
                        </div>
                        <div class="mt-auto" v-if="false">
                            <div class="row">
                                <div class="col-3 h3 text-muted">{{ $t('Total') }}:</div>
                                <div class="col"></div>
                                <div class="col-auto">
                                    <money class="h2 m-0" :value="exam.totalPrice"></money>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3 h3 text-muted">{{ $t('Time') }}:</div>
                                <div class="col"></div>
                                <div class="col-auto">{{ exam.totalTime }} min</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="tab =='notes'">
                <div class="row">
                    <div class="col-6">
                        <div class="card card-info mt-4">
                            <div class="card-header p-3">{{ $t('Other ways of examination') }}</div>

                            <div class="card-body p-2">
                                <b-form-textarea
                                    id="textarea"
                                    v-model="exam.otherWaysOfExamination"
                                    rows="3"
                                    max-rows="6"
                                ></b-form-textarea>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card card-info mt-4">
                            <div class="card-header p-3">{{ $t('Notes') }}</div>
                            <div class="card-body p-2">
                                <b-form-textarea id="textarea" v-model="exam.notes" rows="3" max-rows="6"></b-form-textarea>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card card-info mt-4">
                            <div class="card-header p-3">{{ $t('Status localis') }}</div>
                            <div class="card-body p-2">
                                <b-form-textarea id="textarea" v-model="exam.statusLocalis" rows="3" max-rows="6"></b-form-textarea>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card card-info mt-4">
                            <div class="card-header p-3">{{ $t('Recommendations') }}</div>

                            <div class="card-body p-2">
                                <b-form-textarea
                                    id="textarea"
                                    v-model="exam.recommendations"
                                    :placeholder="$t('Ex. rinse mouth twice a day')"
                                    rows="3"
                                    max-rows="6"
                                ></b-form-textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <odb-modal id="OdbModal" :useAction="useOdb"></odb-modal>
        <cdb-modal id="CdbModal" :useAction="useCdb"></cdb-modal>
        <i-c-d-modal id="ICDModal" :useAction="use"></i-c-d-modal>
        <i-c-d-modal id="ICDModalFinal" :useAction="useFinal"></i-c-d-modal>
        <treatment-browser id="TreatmentBrowserModal1" :useAction="useTreamentAction"/>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Renderer from '@/components/Builder/Renderer.vue'
import SpecialtySelect from '@/components/SpecialtySelect'
import SpecialtyNav from '@/components/SpecialtyNav'
import CustomSwitch from "@/components/CustomSwitch.vue";
import { icdMixins } from '@/components/ICD10/icd-mixins.js'
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
import ICDModal from '@/components/ICD10/ICDModal.vue';
import OdbModal from '@/components/OdbModal.vue';
import CdbModal from '@/components/CdbModal.vue';
import debounce from 'lodash/debounce';
import ToothMap from '@/components/ToothMap.vue';
import Treatment from './Exam/Treatment.vue';
import ToothParts from "@/components/Tooth/Parts.vue";
import Money from '@/components/Money';
import { TreatmentMixin } from '@/mixins/treatment';
import TreatmentBrowser from '@/components/TreatmentBrowser';
import TreatmentLoop from '@/components/TreatmentLoop';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { conditionsArray } from '@/filters/condition.js';
import draggable from 'vuedraggable'

export default {
    props: ['id'],
    mixins: [modalMixins, TreatmentMixin],
    components: {
        draggable,
        Modal,
        Money,
        Renderer,
        OdbModal,
        ToothMap,
        CdbModal,
        ICDModal,
        Treatment,
        ToothParts,
        Treeselect,
        CustomSwitch,
        TreatmentLoop,
        SpecialtySelect,
        SpecialtyNav,
        TreatmentBrowser

    },
    data() {
        return {
            presetSpecialty: null,
            presetParams: {
                query: {}
            },
            presetQuery: null,
            modified: false,
            saveAsPreset: false,
            automatic: false,
            newPresetName: '',
            title: this.$t('Tooth #'),
            tab: 'complaints',
            objectively: {},
            complaints: {},
            odbList: [],
            exam: {
                totalPrice: 0,
                totalTime: 0,
                complaints: {},
                objectively: [],
                diagnosis: [],
                condition: [],
                cdb: [],
                odb: [],
                icd: [],
                diagnosisFinal: [],
                treatmentPlan: [],
                treatments: [],
                customerId: this.$route.params.id,
            }
        }
    },
    watch: {
        presetSpecialty: debounce(function (newVal) {

            console.log('presetSpecialty', newVal);

            delete this.presetParams.query.userId;
            delete this.presetParams.query.specialty;
            delete this.presetParams.query._id;

            if (newVal.length > 0) {
                if (newVal == 'my') {
                    this.presetParams.query.userId = this.user._id;
                } else if (newVal == 'recent') {
                    this.presetParams.query._id = { $in: this.user.recentPresets };
                } else {
                    this.presetParams.query.specialty = { $in: newVal };
                }
            }

            this.fetchPresets(this.presetParams);

        }, 100),
        presetQuery: debounce(function (newVal) {


            delete this.presetParams.query.userId;
            delete this.presetParams.query.specialty;
            delete this.presetParams.query._id;

            if (newVal) {
                this.presetParams.query.$or = [{
                    label: {
                        $regex: newVal,
                        $options: "i"
                    }
                },]
            } else {
                delete this.presetParams.query.$or;
            }

            this.fetchPresets(this.presetParams);

        }, 300),
        exam: {
            handler() {
                this.modified = true;
            },
            deep: true,
        }
    },
    computed: {
        ...mapState('auth', ['user']),
        ...mapState('treatment', { areTreatmentsLoading: 'isFindPending' }),
        ...mapGetters('treatment', { findTreatmentInStore: 'find' }),
        ...mapGetters('presets', { findPresetInStore: 'find' }),
        ...mapState('presets', { arePresetsLoading: 'find' }),
        ...mapGetters('customers', { getCustomer: 'get' }),
        ...mapGetters('my-company', {
            getCompanyFromStore: 'get'
        }),

        customer() {
            return this.getCustomer(this.exam.customerId);
        },

        frontToothLoader() {
            console.log('currentToothLoader', this.exam.tooth);// DO NOT REMOVE THIS LINE , I DON'T KNOW WHY !!!
            let tooth = this.exam.tooth;
            if ( this.$settings.dentalChart === 'usa' )
                tooth = this.$usa2fdi(tooth);
            return () => import(`@/components/Teeth/Front/${ tooth }`);
        },
        oralToothLoader() {
            console.log('currentToothLoader', this.exam.tooth);// DO NOT REMOVE THIS LINE , I DON'T KNOW WHY !!!
            let tooth = this.exam.tooth;
            if ( this.$settings.dentalChart === 'usa' )
                tooth = this.$usa2fdi(tooth);
            return () => import(`@/components/Teeth/Oral/${ tooth }`);
        },

        conditions() {
            let items = this.$copy(conditionsArray());
            let result = [];
            items.forEach(item => {
                let row = {
                    id: item.value,
                    label: this.$t(item.label) + ' (' + this.$t(`conditionCodes.${ item.abbr }`) + ')'
                };

                result.push(row);
            });
            return result;
        },
        presets() {
            return this.findPresetInStore(this.presetParams).data;
        },
        fields() {
            let company = this.getCompanyFromStore("mine");
            let idx = company.fields.findIndex(row => 'exam' === row.location);
            return [company.fields[idx]];
        }
    },
    methods: {
        ...mapActions('exam', ['create', 'patch']),
        ...mapActions('cdb', { findInCdb: 'find' }),
        ...mapActions('odb', { findInOdb: 'find' }),
        ...mapActions('treatment', { findTreatments: 'find' }),
        ...mapActions('presets', { fetchPresets: 'find', createPreset: 'create' }),
        ...mapActions('users', { updateUser: 'patch' }),


        set(preset) {
            this.updateUser([this.user._id, {
                $addToSet: {
                    recentPresets: preset._id
                }
            }, {}]);

            this.automatic = true;
            this.exam.icd = preset.icd;
            this.exam.cdb = preset.cdb;
            this.exam.odb = preset.odb;

            this.exam.statusLocalis = preset.statusLocalis;
            this.exam.otherWaysOfExamination = preset.otherWaysOfExamination;
            this.exam.recommendations = preset.recommendations;
            // this.odbList = preset.odb;
            this.exam.diagnosis = preset.icd;
            this.exam.diagnosisFinal = preset.icdFinal;
            setTimeout(() => {
                this.exam.treatments = preset.treatments;
                this.tab = 'treatment';

            }, 100);
            this.$toasted.global.success({
                message: this.$t('Preset has been applied')
            });


        },
        treatments() {
            return this.findTreatmentInStore().data;
        },
        providersParams(service) {

            const dayOfweeks = {
                1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday', 7: 'sunday'
            }
            const dayOfweek = dayOfweeks[this.$moment(this.data.appointmentAt).isoWeekday()];
            return {

                query: {
                    // 'schedule.dayOfWeek': dayOfweek,
                    treatments: { $in: [service._id] }
                }
            }
        },

        removeTreatment(idx) {
            this.exam.treatmentPlan.splice(idx, 1);
        },

        getOdb(query) {
            return this.findInOdb(query);
        },

        findPreDiagnosis() {

            return this.findInCdb({
                query: {}
            })
        },

        shown() {
            this.saveAsPreset = false;
            this.fetchPresets(this.presetParams);
            const { Exam } = this.$FeathersVuex;
            let data = Exam.getFromStore('temp');
            console.log(data)
            if (data) {
                console.log('data', data)
                delete data._id;
                this.data = JSON.parse(JSON.stringify(data));

                new Exam({
                    model: {},
                    _id: 'temp'
                });
            }

            if (this.data.exam) {
                this.tab = 'diagnosis';
                this.tab = 'treatment';
            } else {
                this.tab = 'presets';
                this.presetSpecialty = 'recent';
                // this.specialtyIds = [this.user.specialtyId];
                // this.openModal({ id: 'CdbModal', model: {} });
            }

            let elementary_conditions = []
            if (this.customer.elementaryExam.map) {
                this.customer.elementaryExam.map.forEach(item => {
                    if (item.tooth === data.tooth) {
                        elementary_conditions.push(item.diagnosis)
                    }
                })
            }

            this.exam = {
                tooth: data.tooth,
                objectively: [],
                complaints: {},
                diagnosis: [],
                condition: elementary_conditions,
                cdb: [],
                odb: [],
                ortopedical: {},
                therapeutic: {},
                diagnosisFinal: [],
                treatmentPlan: [],
                treatments: [],
                parts: {
                    front: {},
                    oral: {}
                },
                customerId: this.$route.params.id,
            }
            Object.assign(this.exam, this.data.exam);
        },
        saveAction() {
            let promise, successMessage;


            if (this.exam._id) {
                promise = this.patch([this.exam._id, this.exam]);
                successMessage = this.$t('Exam has been saved');
            } else {
                promise = this.create(this.exam);
                successMessage = this.$t('Exam has been created');
            }


            promise.then(data => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });


                if (this.exam.newPresetName) {
                    console.log('data', {
                        label: data.newPresetName,
                        ...this.exam
                    });

                    this.createPreset({
                        label: this.exam.newPresetName,
                        ...this.exam
                    });
                }
            });

            this.$root.$emit('bv::hide::modal', this.id);

        },
        removeDiangosis(index) {
            this.exam.diagnosis.splice(index, 1);
        },
        removeDiangosisFinal(index) {
            this.exam.diagnosisFinal.splice(index, 1);
        },
        removeCdb(index) {
            this.exam.cdb.splice(index, 1);
        },
        removeOdb(index) {
            this.exam.odb.splice(index, 1);
        },
        useCdb(item) {
            this.exam.cdb.push(item);
        },
        useOdb(item) {
            this.exam.odb.push(item);
        },
        use(item) {
            this.exam.diagnosis.push(item);
        },
        useFinal(item) {
            this.exam.diagnosisFinal.push(item);
        },
        validation() {

        },


        useTreamentAction(item) {
            this.exam.treatments.unshift(item);
        },

        conditionLabel(condition) {
            let conditions = this.$copy(conditionsArray())
            let obj = conditions.find(o => o.value === condition)
            if (!obj)
                return
            return this.$t(`conditionCodes.${ obj.abbr }`);
        },

        clearPresetSpecialty() {
            this.presetSpecialty = [];
        }

    }
}
</script>
